import { useParams, Link } from 'react-router-dom';
import { categories, getComicsByCategory, tagList } from '@/mocks/comics';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ComicCard from '@/components/base/ComicCard';
import SEOSchema from '@/components/base/SEOSchema';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const comics = slug ? getComicsByCategory(slug) : [];

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-16 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-3">分类不存在</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 transition-colors">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <SEOSchema type="WebPage" data={{
        name: `${category.name} - 香蕉漫画`,
        description: category.description,
        url: `https://banana-comic.com/category/${slug}`,
        inLanguage: 'zh-CN',
        isPartOf: { '@type': 'WebSite', name: '香蕉漫画', url: 'https://banana-comic.com' },
      }} />
      <SEOSchema type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://banana-comic.com/' },
          { '@type': 'ListItem', position: 2, name: category.name, item: `https://banana-comic.com/category/${slug}` },
        ],
      }} />

      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: category.name }]} />

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="mb-10">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              {category.name}推荐
            </h1>
            <p className="text-sm text-foreground-600">{category.description}</p>
          </div>

          {/* Category tabs */}
          <div className="flex items-center gap-2 mb-8 overflow-x-auto flex-wrap pb-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Tag filters */}
          <div className="flex items-center gap-2 mb-8 overflow-x-auto flex-wrap">
            <span className="text-sm text-foreground-500 mr-1 whitespace-nowrap">热门标签：</span>
            {tagList.map((tag) => (
              <span
                key={tag}
                className={`px-3 py-1 rounded-full text-xs transition-colors whitespace-nowrap cursor-pointer ${
                  category.name === tag
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-secondary-100 text-secondary-800 hover:bg-secondary-200'
                }`}
              >
                {tag}
              </span>
            ))}
          </div>

          {comics.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
              {comics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-book-open-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">暂无该分类的漫画，敬请期待</p>
            </div>
          )}
        </section>
      </main>
      <Footer />
    </>
  );
}